 (() => {
  // Trigger events when going between breakpoints
  const mqList = [{
    name: 'Mobile',
    screen: '(max-width: 749px)'
  },
  {
    name: 'ExtraLarge',
    screen: '(max-width: 1024px)'
  }];

  mqList.forEach((breakpoint) => {
    window.matchMedia(breakpoint.screen).onchange = (event) => {
      if (event.matches) {
        document.dispatchEvent(new CustomEvent(`match${breakpoint.name}`));
      } else {
        document.dispatchEvent(new CustomEvent(`unmatch${breakpoint.name}`));
      }
    }
  });
})();

function getScrollbarWidth() {
  const width = window.innerWidth - document.documentElement.clientWidth;

  if (width > 17) return;
  document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
}

getScrollbarWidth();

// Media
window.matchMedia('(max-width: 1024px)').addEventListener('change', () => {
  getScrollbarWidth();
});

// Scroll Text Animation
function loadScrolling() {
  document.querySelectorAll('.title-scroll-wrapper').forEach(element => {
    this.scrollText(element);
  })
}

function scrollText(element) {
  const $titleScroll = element.querySelector('.title-scroll');

  if ($titleScroll) {
    const animate = (element,position) => {
       element.style.transform = `translateX(${position}px)`
    } 

    document.addEventListener('scroll', function(e) {
      lastKnownScrollPosition = window.scrollY;
      window.requestAnimationFrame(function() {
          animate($titleScroll,(lastKnownScrollPosition*.2) + 80)
      });
    });
  }
}

// Calc heigt of header
function headerHeight() {
  const header = document.querySelector('.hlt-header');
  const slideshowContent = document.querySelectorAll('.slideshow__text-wrapper');

  if (header) {
    const headerHeight = header.offsetHeight - 1 + 'px';
    const headerHeightSlideshow = header.offsetHeight + 27 + 'px';
    var dropdownMenu = document.querySelectorAll('.dropdown-menu--content');
    var sectionHeader = document.querySelector('.list-menu-level-1').offsetHeight;
    var listMenu = document.querySelector('.list-menu-level-1');

    if (sectionHeader > 52) {
      dropdownMenu.forEach((summary) => {
        summary.style.setProperty('--top-position', 'auto');
        summary.style.setProperty('--margin-top', '3.1rem');
      })
      listMenu.style.setProperty('--list-menu-height', '4rem');
    } else {
      dropdownMenu.forEach((summary) => {
        summary.style.setProperty('--top-position', headerHeight);
        summary.style.setProperty('--margin-top', '0');
      })
      listMenu.style.setProperty('--list-menu-height', headerHeight);
    }

    if (slideshowContent) {
      slideshowContent.forEach((slide) => {
        slide.style.paddingTop = headerHeightSlideshow;
      })
    }
  }
}

// Preloading Screen Annimate
function logoReveal() {
  const preloadScreen = document.querySelector('.preload-screen');
  if (preloadScreen) setTimeout(() => {preloadScreen.classList.add("off--ready")}, 10);
}

function pageReveal() {
  const body = document.body;
  const preloadScreen = document.querySelector('.preload-screen');
  
  if (preloadScreen) {
    setTimeout(() => {
      preloadScreen.classList.add("off");
      body.classList.add("off");
    }, 600);

    setTimeout(() => {
      preloadScreen.classList.add("loaded");
      body.classList.add("loaded");
      body.classList.remove("preloading-o-h");
      getScrollbarWidth();
    }, 1200);
  }  
}

function scrollTriggerCenter(element) {
  gsap.registerPlugin(ScrollTrigger);
  const data = {
    opacity: 1,
    stagger: 0.04,
    ease: "power2.out",
    scrollTrigger: {
      trigger: element,
      start: "top 70%",
      end: "bottom 50%",
      scrub: true,
      market: true
    }
  }

  return data;
}

function padding_cookie_banner() {
  var banner_cookie = document.querySelector('.shopify-pc__banner__dialog');
  if (banner_cookie != undefined) {
    if (document.querySelector('.announcement-vertical_left') != undefined || document.querySelector('.announcement-vertical_right') != undefined) {
      banner_cookie.classList.add('shopify-pc__banner__dialog_padding');
    }
  }
}

function openFormMessage(queryKey = 'contact_posted', drawerSelectorPrefix = 'Drawer-Back-in-stock-', delay = 1500) {
  const params = new URLSearchParams(window.location.search);
  const shouldOpen = params.get(queryKey);

  if (shouldOpen === 'true') {
    const drawer = document.querySelector(`[id^="${drawerSelectorPrefix}"]`);
    if (drawer) {
      setTimeout(() => {
        drawer.classList.add('animate', 'active');
      }, delay);
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  loadScrolling();
  logoReveal();
  pageReveal();
  headerHeight();
  openFormMessage();
  if (document.querySelector('body').classList.contains('template-index')) {
    setTimeout(() => {
      this.padding_cookie_banner();
    }, 120);
  }
});

window.addEventListener('resize', () => {
  headerHeight();
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('side-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class ProductCardVideoSwap {
  constructor() {
    if (window.innerWidth <= 1025) return;

    document.querySelectorAll('.card-wrapper .card__media.has-product-video').forEach(card => {
      const video = card.querySelector('video');
      if (!video) return;

      card.onmouseenter = () => video.play();
      card.onmouseleave = () => video.pause();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new ProductCardVideoSwap());

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement, event);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      const focusElement = detailsElement.querySelector('button') || this.querySelector('.drawer__close');
      
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 1024px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && !parentMenuElement.matches('.mobile-facets__main') && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {    
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement, event);
  }

  closeSubmenu(detailsElement, event) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    const closeButton = '.drawer__close'

    if (event.target.matches(closeButton) || event.target.closest(closeButton)) document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.menuDrawer = document.querySelector('header-drawer');

    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');
    this.menuDrawer.classList.add('active');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    window.removeEventListener('resize', this.onResize);
  }

  close() {
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden','overflow-hidden-tablet','overflow-hidden-mobile');
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}
customElements.define('header-drawer', HeaderDrawer);

class HeaderMenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('[id^="Drawer-Overlay-"]')?.addEventListener('click', this.close.bind(this));
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    if(!this.dataset.moved) document.body.appendChild(this);
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    if (this.querySelector(`.side-drawer:not(.no-animation--popup)`)) {
      this.addEventListener('transitionstart', () => {
        document.body.classList.add('drawer--opening');
        document.body.classList.remove('drawer--open','drawer--closing');
      }, { once: true });

      this.addEventListener('transitionend', () => {
        document.body.classList.remove('drawer--opening','drawer--closing');
        document.body.classList.add('drawer--open');
      }, { once: true });
    }

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this;
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
      if (this.querySelector(`.side-drawer:not(.no-animation--popup)`)) {
        document.body.classList.remove('drawer--opening','drawer--closing');
        document.body.classList.add('drawer--open');
      }
    }, { once: true });
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    if (document.body.classList.contains)
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden-tablet');
    document.body.classList.remove('overflow-hidden-mobile');

    if (this.querySelector(`.side-drawer:not(.no-animation--popup)`)) {
      this.addEventListener('transitionstart', () => {
        document.body.classList.add('drawer--closing');
        document.body.classList.remove('drawer--opening','drawer--open');
      }, { once: true });

      this.addEventListener('transitionend', () => {
        document.body.classList.remove('drawer--closing','drawer--opening','drawer--open');
      }, { once: true });
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');

    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }
}
customElements.define('header-menu-drawer', HeaderMenuDrawer);


function buildStyleSheet(name, $this) {
  if (name == '') return;
  const loadStyleSheet = document.createElement("link");
  loadStyleSheet.rel = 'stylesheet';
  loadStyleSheet.type = 'text/css';
  loadStyleSheet.href = name;
  $this.querySelector('.url__data').parentNode.insertBefore(loadStyleSheet, $this.querySelector('.url__data'));
}

class SideDrawerOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    let checkLoad = true;

    button.addEventListener('click', () => {
      const drawer = document.querySelector(this.getAttribute('data-side-drawer'));
      if (drawer) drawer.open(button);
    });
  }
}
customElements.define('side-drawer-opener', SideDrawerOpener);

class SideDrawer extends HTMLElement {
  constructor() {
    super();

    document.querySelectorAll('.side-drawer__flex').forEach(button => {
      button.addEventListener('click', () => {
        document.querySelector(button.getAttribute('side-drawer-flex'))?.open(button);
      });
    });

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('[id^="Drawer-Overlay-"]')?.addEventListener('click', this.close.bind(this));

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (e) => {
        const sideMenu = document.querySelectorAll('[id^="Drawer-Side-Menu"]');
        sideMenu.forEach((element, index) => {
          if (element.classList.contains('active')) {
            sideMenu[sideMenu.length - 1].classList.add("active");
          }
          
          if (index+1 < sideMenu.length) {
            element.remove();
          }
          
        });
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    if(!this.dataset.moved) document.body.appendChild(this);
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    if (this.querySelector(`.side-drawer:not(.no-animation--popup)`)) {
      this.addEventListener('transitionstart', () => {
        document.body.classList.add('drawer--opening');
        document.body.classList.remove('drawer--open','drawer--closing');
      }, { once: true });

      this.addEventListener('transitionend', () => {
        document.body.classList.remove('drawer--opening','drawer--closing');
        document.body.classList.add('drawer--open');
      }, { once: true });
    }

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this;
      const focusElement = this.querySelector('.search__input') || this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
      if (this.querySelector(`.side-drawer:not(.no-animation--popup)`)) {
        document.body.classList.remove('drawer--opening','drawer--closing');
        document.body.classList.add('drawer--open');
      }
    }, { once: true });
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    if (this.querySelector(`.side-drawer:not(.no-animation--popup)`)) {
      this.addEventListener('transitionstart', () => {
        document.body.classList.add('drawer--closing');
        document.body.classList.remove('drawer--opening','drawer--open');
      }, { once: true });

      this.addEventListener('transitionend', () => {
        document.body.classList.remove('drawer--closing','drawer--opening','drawer--open');
      }, { once: true });
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('side-drawer', SideDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems= this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderControlButtons = this.querySelectorAll('.slider-button--absolute');
    this.progressBar = this.querySelector(".slider-progress--current");
    this.cardMedia = this.querySelector('[data-cart-media]');
    this.isSliderTransform = this.querySelector('[slider-transform]');
    this.currentOffset = 0;
    this.currentPage = 1;
    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  setArrowsPosition() {
    if (this.sliderControlButtons && this.cardMedia) {
      this.sliderControlButtons.forEach((button) => {
        button.style.top = this.cardMedia.offsetHeight / 2 + "px"
      });
    }
  }

  updateProgressBar() {
    if (!this.progressBar || !this.totalPages) return;
    const progressPercentage = (this.currentPage / this.totalPages) * 100;
    this.progressBar.style.width = `${progressPercentage}%`;
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);

    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    if (this.isSliderTransform) {
      this.currentOffset = (this.currentPage - 1) * this.sliderItemOffset;
      this.setSlideTransformPosition();
    }

    this.update();

    this.setArrowsPosition();
    window.addEventListener('resize', this.setArrowsPosition);

    this.updateProgressBar();
    window.addEventListener('resize', this.updateProgressBar);
    this.addEventListener('slideChanged', this.updateProgressBar.bind(this));
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    if (this.isSliderTransform) {
      this.currentPage = Math.round(this.currentOffset / this.sliderItemOffset) + 1;
    } else {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSliderTransform) {
      this.prevButton.toggleAttribute('disabled', this.currentOffset === 0);
      this.nextButton.toggleAttribute('disabled', this.currentOffset >= (this.totalPages - 1) * this.sliderItemOffset);
    } else {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    const moveDistance = step * this.sliderItemOffset;

    if (this.isSliderTransform) {
      this.currentOffset += event.currentTarget.name === 'next' ? moveDistance : -moveDistance;
      this.update();
      this.sliderItemsToShow.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', index === this.currentPage - 1 ? 'false' : 'true');
      });
      setTimeout(() => this.setSlideTransformPosition(), 400);
    } else {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + moveDistance
          : this.slider.scrollLeft - moveDistance;
      this.setSlidePosition(this.slideScrollPosition);
    }
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }

  setSlideTransformPosition() {
    this.slider.style.transform = `translateX(-${this.currentOffset}px)`;
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return this.querySelector('.slideshow__slide')?.classList.add('is-single-slide');

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });

    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');

      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateWaitlistState();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
    this.updateColorVariantSelect();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateWaitlistState() {
    const sectionRoot = this.closest('[id^="MainProduct-"]') || document.getElementById(`MainProduct-${this.dataset.section}`);
    if (!sectionRoot) return;

    const waitlist = sectionRoot.querySelector('[data-soldout-waitlist]');
    if (!waitlist || !this.currentVariant) return;

    const purchaseActions = sectionRoot.querySelector('.product-form-wrap .product-form__buttons');
    if (!purchaseActions) return;

    const isAvailable = this.currentVariant.available === true;
    const variantLabel = waitlist.querySelector('[data-waitlist-variant]');
    const tagsInput = waitlist.querySelector('[data-waitlist-tags]');
    const title = String(this.currentVariant.title || '');

    if (variantLabel) variantLabel.textContent = title;

    waitlist.dataset.currentVariantId = String(this.currentVariant.id || '');
    waitlist.dataset.currentVariantTitle = title;

    if (tagsInput) {
      const tags = [
        'WAITLIST_SIGNUP',
        'WAITLIST_EMAIL_NOTIFY',
        tagsInput.dataset.campaignTag,
        tagsInput.dataset.productMachineTag,
        'WAITLIST_VARIANT_' + String(this.currentVariant.id || ''),
        'Waitlist Product - ' + String(tagsInput.dataset.productTitle || ''),
        'Waitlist Variant - ' + title.replace(/,/g, ' ')
      ];

      if (tagsInput.dataset.offerTag) tags.push(tagsInput.dataset.offerTag);
      tagsInput.value = tags.filter(Boolean).join(', ');
    }

    if (isAvailable) {
      purchaseActions.classList.remove('waitlist-variant-hidden');
      purchaseActions.hidden = false;
      purchaseActions.removeAttribute('aria-hidden');
      waitlist.hidden = true;
      waitlist.setAttribute('aria-hidden', 'true');
    } else {
      purchaseActions.classList.add('waitlist-variant-hidden');
      purchaseActions.hidden = true;
      purchaseActions.setAttribute('aria-hidden', 'true');
      waitlist.hidden = false;
      waitlist.removeAttribute('aria-hidden');
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const mediaStickyCart = document.querySelector(`#MediaStickyCart-${this.dataset.section}`);
    if (mediaStickyCart) {
      mediaStickyCart.querySelector('img').setAttribute('src', this.currentVariant.featured_image.src);
      mediaStickyCart.querySelector('img').setAttribute('srcset', `${this.currentVariant.featured_image.src}&width=150 150w`);
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-sticky-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;
        const options = Array.from(this.querySelectorAll('.product-form__input'));

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const destinationSticky = document.getElementById(`PriceStickyCart-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const sourceSticky = html.getElementById(
          `PriceStickyCart-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (sourceSticky && destinationSticky) destinationSticky.innerHTML = sourceSticky.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        const priceSticky = document.getElementById(`PriceStickyCart-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        if (priceSticky) priceSticky.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        if (options) {
          var selectedOption1,
              selectedOption2,
              selectedOption3;

          if (options[0]) {
            if (this.nodeName == 'VARIANT-RADIOS') {
              selectedOption1 = Array.from(options[0].querySelectorAll('input')).find((radio) => radio.checked).value;
            } else {
              selectedOption1 = options[0].querySelector('select').value;
            }

            options[0].querySelector('[data-header-option]').textContent = selectedOption1;
          }

          if (options[1]) {
            if (this.nodeName == 'VARIANT-RADIOS') {
              selectedOption2 = Array.from(options[1].querySelectorAll('input')).find((radio) => radio.checked).value;
            } else {
              selectedOption2 = options[1].querySelector('select').value;
            }

            options[1].querySelector('[data-header-option]').textContent = selectedOption2;
          }

          if (options[2]) {
            if (this.nodeName == 'VARIANT-RADIOS') {
              selectedOption3 = Array.from(options[2].querySelectorAll('input')).find((radio) => radio.checked).value;
            } else {
              selectedOption3 = options[2].querySelector('select').value;
            }

            options[2].querySelector('[data-header-option]').textContent = selectedOption3;
          }
        }

        if(this.currentVariant?.inventory_management != null) {
          const productId = this.closest('product-info')?.dataset.productId;
          const inventoryData = window[`productInventory_${productId}`];
          if (!inventoryData) return;

          const quantity = parseInt(inventoryData[this.currentVariant.id]);
          const submitButtons = document.querySelectorAll(
            `#ProductSubmitButton-${sectionId}, #StickyCart-ProductSubmitButton-${sectionId}, #ProductSubmitButton-quickadd-${sectionId}`
          );

          submitButtons.forEach((btn) => {
            if (btn) btn.setAttribute('data-inventory-quantity', quantity);
          });
        }

        if (document.querySelector('sticky-cart')) {
          const selectElement = document.querySelector('.product-form__input.sticky-cart__variant').querySelector('select');
          if (!selectElement) return;
          const currentOption = Array.from(selectElement.options).find((option) => Number(option.value) === this.currentVariant.id);
          if (currentOption && !currentOption.selected) currentOption.selected = true;
        }

        const updateButtonStates = html.querySelectorAll(
          `#ProductSubmitButton-${sectionId}, #StickyCart-ProductSubmitButton-${sectionId}`
        );
        updateButtonStates.forEach((addButtonUpdated) => {
          if (!addButtonUpdated) return;
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            window.variantStrings.soldOut
          );
        });

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });

        //Update product badge in product gallery
        document.querySelectorAll('.product-section').forEach((el) => {
          const mainPrice = el.querySelector('.price-product--main .price')?.className;
          const galleryPrice = el.querySelector('[id^="PriceProductGallery-"]');
          if (mainPrice && galleryPrice) galleryPrice.className = mainPrice;
        });

        // Back in stock
        if (document.querySelector('[data-back-in-stock]')) {
          const backInStockButton = document.querySelector(`.product-form__soldout`);
          if (this.currentVariant && !this.currentVariant.available) {
            backInStockButton?.classList.remove('hidden');
          } else {
            backInStockButton?.classList.add('hidden');
          }

          const drawer = document.querySelector(`#Drawer-Back-in-stock-${sectionId}`);
          if (drawer && this.currentVariant) {
            const {
              id: variantId,
              title: variantTitle,
              sku,
            } = this.currentVariant;

            const productHandle = drawer.querySelector('input[name="contact[Product URL]"]')?.value.split('/products/')[1]?.split('?')[0];
            const productBaseUrl = window.location.origin + '/products/' + productHandle;

            const inputVariantTitle = drawer.querySelector('input[name="contact[Product variant]"]');
            const inputVariantSku = drawer.querySelector('input[name="contact[Product sku]"]');
            const inputVariantUrl = drawer.querySelector('input[name="contact[Product URL]"]');

            if (inputVariantTitle) inputVariantTitle.value = variantTitle;
            if (inputVariantSku) inputVariantSku.value = sku || '';
            if (inputVariantUrl) inputVariantUrl.value = `${productBaseUrl}?variant=${variantId}`;

            const notifyHeading = drawer.querySelector('.notify__heading');
            const notifyVariant = drawer.querySelector('.notify__variant');
            if (notifyHeading) notifyHeading.textContent = `${notifyHeading.dataset.productTitle}`;
            if (notifyVariant) notifyVariant.textContent = `${variantTitle}`;
          }
        }
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-sticky-${this.dataset.section}`
    );
    const productFormQuantities = document.querySelectorAll('.product-form__quantity');

    productForms.forEach((productForm, index) => {
      if (!productForm) return;

      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      const maxInventory = parseInt(productForm.querySelector('.product-form__submit').getAttribute('data-inventory-quantity'));
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        productFormQuantities.forEach((quantity) => quantity.classList.add('disabled'));
        if (index === 0) addButton.classList.remove('gradient');
        if (text) addButtonText.textContent = text;

        if (productForm.querySelector('[data-back-in-stock]')) {
          const backInStockButton = productForm.querySelector(`.product-form__soldout`);
          if (this.currentVariant && !this.currentVariant.available) {
            setTimeout(() => {
              backInStockButton?.classList.remove('hidden');
              addButton.setAttribute('data-back-in-stock', 'true');
            }, 10);
          } else {
            setTimeout(() => {
              backInStockButton?.classList.add('hidden');
              addButton.setAttribute('data-back-in-stock', 'false');
            }, 10);
          }
        }
      } else {
        addButton.removeAttribute('disabled');
        if (productForm.querySelector('[data-back-in-stock]')) {
          if (!this.currentVariant && this.currentVariant.available) setTimeout(() => {addButton.setAttribute('data-back-in-stock', 'false')}, 10);
        }
        if (index === 0) addButton.classList.add('gradient');
        productFormQuantities.forEach((quantity) => quantity.classList.remove('disabled'));
        if (this.currentVariant.available && maxInventory <= 0 && this.currentVariant.inventory_management == "shopify") {
          addButtonText.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      if (!modifyClass) return;
    });
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const priceSticky = document.getElementById(`PriceStickyCart-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (priceSticky) priceSticky.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateColorVariantSelect() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    if (this.nodeName == 'VARIANT-RADIOS') {
      this.other = Array.from(this.closest('[id^=MainProduct-]').querySelectorAll('variant-radios')).filter((selector) => {
        return selector != this;
      });
    } else {
      this.other = Array.from(this.closest('[id^=MainProduct-]').querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
    }

    if (this.other.length) {
      const options = Array.from(this.querySelectorAll('.product-form__input'));
      const alterOptions = Array.from(this.other[0].querySelectorAll('.product-form__input'));

      if (options && alterOptions) {
        let selectedOption1;
        let selectedOption2;
        let selectedOption3;

        if (options[0]) {
          if (this.nodeName == 'VARIANT-RADIOS') {
            selectedOption1 = Array.from(options[0].querySelectorAll('input')).find((radio) => radio.checked).value;
            alterOptions[0].querySelector(`input[value="${selectedOption1}"]`).checked = true;
          } else {
            selectedOption1 = options[0].querySelector('select').value;
            alterOptions[0].querySelector('select').value = selectedOption1;
          }

          alterOptions[0].querySelector('[data-header-option]').textContent = selectedOption1;
        }

        if (options[1]) {
          if (this.nodeName == 'VARIANT-RADIOS') {
            selectedOption2 = Array.from(options[1].querySelectorAll('input')).find((radio) => radio.checked).value;
            alterOptions[1].querySelector(`input[value="${selectedOption2}"]`).checked = true;
          } else {
            selectedOption2 = options[1].querySelector('select').value;
            alterOptions[1].querySelector('select').value = selectedOption2;
          }

          alterOptions[1].querySelector('[data-header-option]').textContent = selectedOption2;
        }

        if (options[2]) {
          if (this.nodeName == 'VARIANT-RADIOS') {
            selectedOption3 = Array.from(options[2].querySelectorAll('input')).find((radio) => radio.checked).value;
            alterOptions[2].querySelector(`input[value="${selectedOption3}"]`).checked = true;
          } else {
            selectedOption3 = options[2].querySelector('select').value;
            alterOptions[2].querySelector('select').value = selectedOption3;
          }

          alterOptions[2].querySelector('[data-header-option]').textContent = selectedOption3;
        }
      }
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            if (window.innerWidth > 1025) new ProductCardVideoSwap();
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

window.theme = window.theme || {};
// Init section function when it's visible, then disable observer
theme.initSectionVisible = function(options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, {rootMargin: `0px 0px ${threshold}px 0px`});

  observer.observe(options.element);
};

class AZBrands extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.createObserver();
  }

  init() {
    this.wrapper = document.querySelector('[id^="AZWrapper-"]');
    this.navigation = document.querySelector('[id^="AZTable-"]');

    let list = this.getAttribute('data-brand');
    
    this.getAllBrands(list);
  }

  getAllBrands(list){
    JSON.parse(list).forEach((vendor) => {
      let letter = vendor.letter,
        handle = vendor.handle,
        name = vendor.name,
        brand = `<a href="${handle}" class="dis-block link link--text t-d-none">${name}</a>`,
        item = document.createElement('li'),
        brandGroup;

      item.classList.add('brand', 'over-h', 'center', 'gradient');
      item.setAttribute('data-az-letter', letter);
      item.innerHTML = brand;

      if(this.isNumber(letter)) {
        brandGroup = this.wrapper.querySelector(`.az-group[data-letter="0-9"] ul`);
      } else {
        brandGroup = this.wrapper.querySelector(`.az-group[data-letter="${letter}"] ul`);
      }

      brandGroup.appendChild(item);
    });

    this.parseListBrand();
  }

  parseListBrand(){
    this.wrapper.querySelectorAll('.az-group').forEach((element) => {
      let letter = element.dataset.letter;

      if(element.querySelector('.az-group__list')?.childNodes.length > 0){
        this.navigation.querySelector(`[data-letter="${letter}"]`).classList.remove('disable')
        this.navigation.querySelector(`[data-letter="${letter}"]`).classList.add('has-letter');

        if (this.wrapper.classList.contains('hide-no__brand')) {
          element.classList.add('dis-block');
          element.classList.remove('dis-none');
        }
      }
    });
  }

  isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0)
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          observer.unobserve(this);
          this.init();
        }
      });
    }, {rootMargin: "0px 0px -200px 0px"});

    observer.observe(this);
  }
}
customElements.define('az-brands', AZBrands);

class AZLayout extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.wrapper = document.querySelector('[id^="AZWrapper-"]');
    this.navigation = document.querySelector('[id^="AZTable-"]');

    if(!this.wrapper || !this.navigation) return;

    if(this.navigation.querySelector('button')){
      this.navigation.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', this.onClickHandler.bind(this));
      });
    }
  }

  onClickHandler(event) {
    let letter = event.target.dataset.id;

    this.navigation.querySelectorAll('li').forEach((element) => {
      if(element == event.target.closest('li')) { 
        event.target.closest('li').classList.add('active');
      } else {
        element.classList.remove('active');
      }
    });

    this.wrapper.querySelectorAll('.az-group').forEach((element) => {
      element.classList.remove('dis-block');
      element.classList.add('dis-none');
    });

    if (letter != undefined && letter != null) {
      this.wrapper.classList.remove('active-all');
      this.wrapper.querySelector(`[data-letter="${letter}"]`).classList.remove('dis-none');
      this.wrapper.querySelector(`[data-letter="${letter}"]`).classList.add('dis-block');
    } else {
      if (this.wrapper.classList.contains('hide-no__brand')) {
        this.wrapper.querySelectorAll('.az-group').forEach((element) => {
          if (element.querySelector('.az-group__list')?.childNodes.length > 0) {
            element.classList.add('dis-block');
            element.classList.remove('dis-none');
          }
        })
      } else {
        this.wrapper.classList.add('active-all');
      }
    }
  }
}
customElements.define('az-layout', AZLayout);

//Color Swatches
function colorFormatting(e, mode) {
  switch(mode) {
    case 'hexColor':
      return /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(e);
    case 'image':
      return /(\/\/)([^\s(["<,>/]*)(\/)[^\s[",><]*(.png|.jpg)(\?[^\s[",><]*)?/gi.test(e);
  }
}

class ColorSwatch extends HTMLElement {
  constructor() {
    super();
    this.colorList = null;
    this.swatch = this.querySelectorAll('.js-color-swatch') || [];
    this.data = document.querySelector('#ColorSwatchCodes') || null;
    if (this.data && this.swatch.length) this.load();
  }

  load() {
    new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.init();
          observer.unobserve(this);
        }
      })
    }).observe(this)
  }

  init() {
    this.colorList = JSON.parse(this.data.textContent);
    if (this.colorList) this.colorList = Object.assign.apply({}, this.colorList.color_swatch_key.map((item, i) => ({[item]: this.colorList.color_swatch_value[i]})));
    this.swatch.forEach(item => {
      const variantValue = item.dataset.variantValue;
      const variantValueOfColorList = this.colorList["" + variantValue];
      if (variantValueOfColorList != null && !item.matches('.variant-swatch--image')) {
        if (this.checkMode(variantValueOfColorList, 'image')) this.setImage(item, variantValue);
        else if (this.checkMode(variantValueOfColorList, 'hexColor')) this.setHexColor(item, variantValue);
      }
    });
  }

  setImage(item, variantValue) {
    item.style.removeProperty('--bg-color');
    item.style.setProperty('--bg-image', `url("${this.colorList["" + variantValue]}")`);
    item.classList.add('bg-img-nrcc');
  }

  setHexColor(item, variantValue) {
    item.style.setProperty('--bg-color', this.colorList["" + variantValue]);
  }

  checkMode(variantValue, val) {
    return colorFormatting(variantValue, val);
  }
}

customElements.define('color-swatch', ColorSwatch);

class PreloadScreen extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('page:loaded', () => {
      setTimeout(() => {
        this.classList.add('logo_animate');
      }, 100);

      setTimeout(() => {
        this.setAttribute('loaded', true);
      }, 350);
    });

    document.addEventListener('pointermove', () => {
      document.body.classList.add('function__show');
    }, { once: true });
  }
}

customElements.define('preload-screen', PreloadScreen);

class LookbookPoint extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('.shopify-section');
    this.items = this.section.querySelectorAll('.collage__product--item');
  }

  connectedCallback() {
    this.addEventListener('mouseover', this.onClickButtons.bind(this));
    this.addEventListener('focusin', this.onClickButtons.bind(this));
    this.createObserver();
    document.addEventListener('matchExtraLarge', this.close.bind(this));
    document.addEventListener('unmatchExtraLarge', this.load.bind(this));
    this.items.forEach(item => {item.addEventListener('focusin', this.onFocusInForItems.bind(this))});
  }

  load() {
    if (!this.getAttribute('loaded') && window.matchMedia('(min-width: 1025px)').matches && this.querySelector('template')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.querySelector('.lookbook__point-popup').appendChild(content.firstElementChild);
    }
  }

  onClickButtons(event) {
    const drawer = document.querySelector(this.getAttribute('data-side-drawer'));
    const media = window.matchMedia("(min-width: 1025px)").matches ? true : false;
    const listItems = media ? this.items : drawer.querySelectorAll('.collage__product-drawer--item');

    this.section.querySelectorAll("lookbook-point").forEach((item) => {
      item.classList.remove("active");
    });

    this.open();
    if (!media && drawer) drawer.open(this.button);
    
    listItems.forEach(element => {
      element.classList.remove("active");
      if(this.dataset.position == element.dataset.position) element.classList.add("active");
    });

    if (!media) {
      const position = drawer.querySelector('.collage__product-drawer--item.active')?.offsetLeft;
      drawer.querySelector('.lookbook__drawer-inner').addEventListener('transitionend', function() {
        drawer.querySelector('.lookbook__drawer-wrapper').scrollTo({left: position, behavior: "smooth"});
      })
    }
  }

  onFocusInForItems(event) {
    const collage = event.target.closest('.collage__product--item');
    const index = Number(collage.dataset.position) - 1;
    const points = this.section.querySelectorAll('lookbook-point');
    
    this.items.forEach(item => {item.classList.remove('active')});
    collage.classList.add('active');
    points.forEach(point => {point.classList.remove('active')});
    points[index].classList.add('active');
  }

  open() {
    this.classList.add('active');
  }

  close() {
    this.classList.contains('active') && this.classList.remove('active');
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          observer.unobserve(this);
          this.load();
        }
      });
    }, {rootMargin: "0px 0px -200px 0px"});

    observer.observe(this);
  }
}

customElements.define('lookbook-point', LookbookPoint);

class LookbookDrawer extends SideDrawer {
  constructor() {
    super();
    this.closeButton = this.querySelector('.drawer__close');
    this.overlay = this.querySelector('[id^="Drawer-Overlay-"]');
    this.overlay?.addEventListener('click', this.close.bind(this));
    this.closeButton?.addEventListener('click', this.close.bind(this));
  }

  load() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.querySelector('.side-drawer').appendChild(content.firstElementChild);
    }
  }

  open(triggeredBy) {
    this.load();
    super.open(triggeredBy);
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('lookbook-drawer', LookbookDrawer);

class GridView extends HTMLElement {
  constructor() {
    super();
    this.productGrid = document.querySelector('.product-grid-container .product-grid');
    this.querySelectorAll('.button--grid-view').forEach((button) => {
      button.addEventListener('click', this.changeLayoutGrid.bind(this));
    });
  }

  changeLayoutGrid (event) {
    const gridView = event.currentTarget.dataset.grid;
    this.querySelectorAll('.button--grid-view').forEach((button) => {
      button.classList.add('c-pointer');
      button.classList.remove('active');
    });

    event.currentTarget.classList.remove('c-pointer');
    event.currentTarget.classList.add('active');
    this.productGrid.setAttribute('data-view',gridView);
  }
}

customElements.define('grid-view', GridView);

class HltHeader extends HTMLElement {
  constructor() {
    super();
    this.allowTransparent();

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", this.allowTransparent.bind(this));
      document.addEventListener("shopify:section:unload", this.allowTransparent.bind(this));
      document.addEventListener("shopify:section:reorder", this.allowTransparent.bind(this));
    }
  }

  allowTransparent() {
    if (document.querySelectorAll(".content-for-layout .shopify-section")[0].querySelector('[allow-transparent-header]')) {
      this.setAttribute("allow-transparency", "");
    } else {
      this.removeAttribute("allow-transparency");
      this.classList.remove("is-header-transparent");
    }
  }
}

customElements.define('hlt-header', HltHeader);

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    theme.initSectionVisible({
      element: this,
      callback: this.load.bind(this),
      threshold: 400
    });
  }

  load() {
    fetch(this.getUrl())
      .then(response => response.text())
      .then(text => {
        const recentlyViewed = new DOMParser().parseFromString(text, 'text/html').querySelector('recently-viewed-products');
        if (recentlyViewed) {
          this.innerHTML = recentlyViewed.innerHTML;
          if (window.innerWidth > 1025) new ProductCardVideoSwap();
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  getUrl() {
    const listItems = JSON.parse(localStorage.getItem('_halo_recently_viewed') || '[]');
    if (this.dataset.productId && listItems.includes(parseInt(this.dataset.productId))) listItems.splice(listItems.indexOf(parseInt(this.dataset.productId)), 1);
    return this.dataset.url + listItems.map((id) => 'id:' + id).slice(0, parseInt(this.dataset.limit)).join('%20OR%20');
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);

class CountDown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.d = new Date(this.dataset.countdown).getTime();
    this.t = this.dataset.type;
    this.e = this.dataset.hide;
    this.createObserver();
  }

  init(time, type, hide) {
    var countdown = setInterval(() => {
      let now = new Date().getTime();

      if (isNaN(time)) {
        time = new Date(this.dataset.countdown.replace(/-/g, "/")).getTime();
  
        if (isNaN(time)) {
          clearInterval(countdown);
          this.parentElement.classList.add('hidden');
          return;
        }
      }

      let distance = time - now;

      if (distance < 0) {
        clearInterval(countdown);
        if (hide == 'true') {
          this.parentElement.classList.add('hidden');
        } else {
          let content = `<span class="countdown-item dis-i-block v-a-top center"><span class="dis-flex a-i-center j-c-center countdown-digit h5 typography-font-body f-w-semibold pos-relative">0</span><span class="dis-block t-uppercase body-sm">${window.countdown.day}</span></span>\
              <span class="countdown-item dis-i-block v-a-top center wid-auto"><span class="dis-flex a-i-center j-c-center countdown-digit h5 typography-font-body f-w-semibold pos-relative">0</span><span class="dis-block t-uppercase body-sm">${window.countdown.hour}</span></span>\
              <span class="countdown-item dis-i-block v-a-top center wid-auto"><span class="dis-flex a-i-center j-c-center countdown-digit h5 typography-font-body f-w-semibold pos-relative">0</span><span class="dis-block t-uppercase body-sm">${window.countdown.min}</span></span>\
              <span class="countdown-item dis-i-block v-a-top center wid-auto"><span class="dis-flex a-i-center j-c-center countdown-digit h5 typography-font-body f-w-semibold pos-relative">0</span><span class="dis-block t-uppercase body-sm">${window.countdown.sec}</span></span>`;
              
          this.querySelector('.countdown').innerHTML = content;
          this.querySelector('.countdown-expired').classList.remove('hidden');
        }
      } else {
        let day = Math.floor(distance / (1000 * 60 * 60 * 24)),
          hour = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minute = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          second = Math.floor((distance % (1000 * 60)) / 1000),
          content;

          if(type == 'product') {
            content = `<span class="countdown-item dis-i-block v-a-top center"><span class="dis-flex a-i-center j-c-center countdown-digit h5 typography-font-body f-w-semibold pos-relative">${day}</span><span class="dis-block t-uppercase body-sm">${window.countdown.day}</span></span>\
              <span class="countdown-item dis-i-block v-a-top center wid-auto"><span class="dis-flex a-i-center j-c-center countdown-digit h5 typography-font-body f-w-semibold pos-relative">${hour}</span><span class="dis-block t-uppercase body-sm">${window.countdown.hour}</span></span>\
              <span class="countdown-item dis-i-block v-a-top center wid-auto"><span class="dis-flex a-i-center j-c-center countdown-digit h5 typography-font-body f-w-semibold pos-relative">${minute}</span><span class="dis-block t-uppercase body-sm">${window.countdown.min}</span></span>\
              <span class="countdown-item dis-i-block v-a-top center wid-auto"><span class="dis-flex a-i-center j-c-center countdown-digit h5 typography-font-body f-w-semibold pos-relative">${second}</span><span class="dis-block t-uppercase body-sm">${window.countdown.sec}</span></span>`;
              
              this.querySelector('.countdown').innerHTML = content;
              this.parentElement.classList.remove('hidden');
          }
      }
    }, 1000);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        this.init(this.d, this.t, this.e);
        observer.unobserve(this);
      });
    }, {rootMargin: "0px 0px -200px 0px"});

    observer.observe(this);
  }
}

customElements.define('count-down', CountDown);

class StickyVariantSelects extends VariantSelects {
  constructor() {
    super();
  }

  decodeOptions() {
    this.options = this.options.map(this.decodeOption);
  }

  decodeOption(option) {
    return option
      ? option.replaceAll('Special_Double_Quote', '"').replaceAll('Special_Slash', '/')
      : null;
  }

  updateMasterId() {
    this.decodeOptions();
    this.currentVariant = this.getVariantData().find(
      (variant) => variant.id == this.options
    );
  }

  renderProductInfo() {
    const variantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection || this.dataset.section;
    const url = `${this.dataset.url}?variant=${variantId}&section_id=${sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((htmlText) => {
        if (this.currentVariant.id !== variantId) return;
        const doc = new DOMParser().parseFromString(htmlText, 'text/html');

        const ids = [
          'price', 'PriceStickyCart', 'Sku', 'Inventory', 'Volume', 'Price-Per-Item'
        ];

        ids.forEach((id) => {
          const from = doc.getElementById(`${id}-${sectionId}`);
          const to = document.getElementById(`${id}-${this.dataset.section}`);
          if (!from || !to) return;

          to.innerHTML = from.innerHTML;
          if (id === 'Sku' || id === 'Price-Per-Item') {
            to.classList.toggle('visibility-hidden', from.classList.contains('visibility-hidden'));
          }
        });

        ['price', 'PriceStickyCart'].forEach((id) => {
          const el = document.getElementById(`${id}-${this.dataset.section}`);
          if (el) el.classList.remove('visibility-hidden');
        });

        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        const inventorySource = doc.getElementById(`Inventory-${sectionId}`);
        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource?.innerText === '');

        this.updateOptionsUI();
        this.updateInventoryQuantity(sectionId);

        const updateButtons = doc.querySelectorAll(
          `#ProductSubmitButton-${sectionId}, #StickyCart-ProductSubmitButton-${sectionId}`
        );
        updateButtons.forEach((btn) => {
          if (!btn) return;
          this.toggleAddButton(
            btn.hasAttribute('disabled'),
            window.variantStrings.soldOut
          );
        });

        publish(PUB_SUB_EVENTS.variantChange, {
          data: { sectionId, html: doc, variant: this.currentVariant },
        });

        //Update product badge in product gallery
        document.querySelectorAll('.product-section').forEach((el) => {
          const mainPrice = el.querySelector('.price-product--main .price')?.className;
          const galleryPrice = el.querySelector('[id^="PriceProductGallery-"]');
          if (mainPrice && galleryPrice) galleryPrice.className = mainPrice;
        });
      });
  }

  updateOptionsUI() {
    const options = [...document.querySelectorAll('.product-form__input:not(.product-form__quantity)')];
    const { option1, option2, option3 } = this.currentVariant || {};
    [option1, option2, option3].forEach((selected, i) => {
      const input = options[i];
      if (!input) return;

      const closest = input.closest('variant-radios');
      const inputs = input.querySelectorAll('input, select option');

      const target = [...inputs].find((el) => el.value === selected);
      if (target) target.checked = target.selected = true;

      const label = input.querySelector('[data-header-option]');
      if (label) label.textContent = selected;
    });

    const variantSelect = this.querySelector('select');
    if (variantSelect) {
      const match = [...variantSelect.options].find((o) => Number(o.value) === this.currentVariant.id);
      if (match) match.selected = true;
    }
  }

  updateInventoryQuantity(sectionId) {
    const productId = document.querySelector('product-info')?.dataset.productId;
    const inventoryData = window[`productInventory_${productId}`];
    if (!inventoryData) return;

    const quantity = parseInt(inventoryData[this.currentVariant.id]);
    const buttons = document.querySelectorAll(
      `#ProductSubmitButton-${sectionId}, #StickyCart-ProductSubmitButton-${sectionId}`
    );

    buttons.forEach((btn) => btn?.setAttribute('data-inventory-quantity', quantity));
  }
}

customElements.define('sticky-variant-selects', StickyVariantSelects);

class StickyCart extends HTMLElement {
  constructor() {
    super();

    this.form = document.getElementById(this.getAttribute('product-form'));
    this.footer = document.querySelector('.shopify-section-group-footer-group');
    this.button = this.querySelector('.sticky-cart__button');
    this.content = this.querySelector('.sticky-cart__content');

    if (!this.form || !this.footer || !this.button) return;

    const observer = new IntersectionObserver(this.onScroll.bind(this));
    observer.observe(this.form);
    observer.observe(this.footer);

    this.toggleHandler = this.onToggle.bind(this);
    this.manageToggleEvent();
    window.addEventListener('resize', this.manageToggleEvent.bind(this));
  }

  onScroll(entries) {
    entries.forEach((entry) => {
      if (entry.target === this.form) this.passedForm = entry.boundingClientRect.bottom < 0;
      if (entry.target === this.footer) this.reachedFooter = entry.isIntersecting;
    });

    const shouldShow = this.passedForm && !this.reachedFooter;
    document.body.classList.toggle('sticky-cart-visible', shouldShow);
    this.classList.toggle('is-visible', shouldShow);

    if (!shouldShow) this.classList.remove('sticky-open');
  }

  manageToggleEvent() {
    const isMobile = window.matchMedia('(max-width: 1024px)').matches;

    this.button.removeEventListener('click', this.toggleHandler);
    if (isMobile) {
      this.button.addEventListener('click', this.toggleHandler);
    }
  }

  onToggle(e) {
    e.preventDefault();
    const isOpen = !!this.content.style.maxHeight;
    this.content.style.maxHeight = isOpen ? null : `${this.content.scrollHeight}px`;
    this.classList.toggle('sticky-open', !isOpen);
  }
}

customElements.define('sticky-cart', StickyCart);

if (!customElements.get('product-tab-component')) {
  customElements.define('product-tab-component', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('.button-tab')];
      this.contents = [...this.querySelectorAll('.content-tab')];

      this.tabs?.forEach(tab => {
        tab.addEventListener('click', e => this.activateTab(e.currentTarget));
      });
    }

    activateTab(tab) {
      if (tab.hasAttribute('active')) return;

      this.tabs.forEach(t => t.removeAttribute('active'));
      tab.setAttribute('active', '');

      this.contents.forEach(content => {
        const isMatch = content.dataset.contentTabIndex === tab.dataset.tabIndex;
        content.toggleAttribute('open', isMatch)

        if (isMatch) this.renderContent(content);
      });
    }

    renderContent(content) {
      const template = content.querySelector('template');
      if (template && !template.nextElementSibling) content.appendChild(template.content.cloneNode(true));
    }
  });
}

class ScrollRevealBanner extends HTMLElement {
  connectedCallback() {
    const splitText = this.querySelector('.reveal-text');
    if (!splitText) return;

    const words = splitText.textContent.trim().split(/\s+/);
    splitText.innerHTML = words.map(word => `<span class="word">${word}</span>`).join(' ');

    const wordEls = splitText.querySelectorAll('.word');
    gsap.to(wordEls, scrollTriggerCenter(splitText));
  }
}

customElements.define('scroll-reveal-banner', ScrollRevealBanner);